import { useParams } from '@gogame/screens';
import { useScreenMessage } from '@gogame/screens';

import { saveNodesMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/sources/plan';

export const useSaveNodesMarketingPlan = () => {
  const { showErrorMessage } = useScreenMessage();
  const { year, month } = useParams();
  return data => {
    return saveNodesMarketingPlan({ year, month, data }).catch(e => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
  };
};
